module.exports = __webpack_public_path__ + "img/43b0006.png";